import { useState, useEffect } from 'react'
import { receptionStatusManager } from '../services/receptionStatusManager'

// React Hook for reception status management
export const useReceptionStatus = () => {
  const [status, setStatus] = useState(() => receptionStatusManager.getStatus())

  useEffect(() => {
    // Listen for status changes
    const unsubscribe = receptionStatusManager.addListener((event) => {
      setStatus(event.current)
    })

    // Cleanup on unmount
    return unsubscribe
  }, [])

  return {
    status,
    updateStatus: (newStatus, options) => receptionStatusManager.updateStatus(newStatus, options),
    isActive: () => receptionStatusManager.isActive(),
    isStopped: () => receptionStatusManager.isStopped(),
    isMaintenance: () => receptionStatusManager.isMaintenance(),
    isMaintenanceMode: () => receptionStatusManager.isMaintenanceMode(),
    startMaintenance: (message) => receptionStatusManager.startMaintenance(message),
    stopMaintenance: () => receptionStatusManager.stopMaintenance(),
    startReception: () => receptionStatusManager.startReception(),
    stopReception: () => receptionStatusManager.stopReception(),
    getDebugInfo: () => receptionStatusManager.getDebugInfo()
  }
}

export default useReceptionStatus